import { MessageBar, MessageBarType } from '@fluentui/react';

const MessageBarComponent = ({
  messageType = MessageBarType.info, 
  message = '',
  showMessage = false,
  setShowMessage,
  isMultiline = false,
  dismissButtonAriaLabel = 'Close',
}) => {
  if (!showMessage) return null;

  return (
    <MessageBar
      messageBarType={messageType}
      isMultiline={isMultiline}
      dismissButtonAriaLabel={dismissButtonAriaLabel}
      onDismiss={() => setShowMessage(false)}
      className="mt-1"
    >
      {message}
    </MessageBar>
  );
};

export default MessageBarComponent;
